import React, { FC } from 'react';

import { LinkWrapper } from '../links/LinkWrapper';
import {
  ButtonColor,
  PrimaryButton,
  PrimaryButtonProps,
} from './PrimaryButton';

export const LogInButton: FC<Omit<PrimaryButtonProps, 'buttonColor'>> = ({
  ...rest
}) => (
  <LinkWrapper to="https://app.retirable.com/login?utm_source=website">
    <PrimaryButton {...rest} buttonColor={ButtonColor.Transparent}>
      Log In
    </PrimaryButton>
  </LinkWrapper>
);
